import App, { Container } from 'next/app';
import React from 'react';
import Head from 'next/head';
import Router from 'next/router';

export default class CustomApp extends App {
    static async getInitialProps({ Component, router, ctx }) {
        let pageProps = {};
        if (Component.getInitialProps) {
            pageProps = await Component.getInitialProps(ctx);
        }
        return { pageProps };
    }

    trackPageView(url) {
        try {
            window.gtag('config', 'UA-147476632-1', {
                page_location: url
            });
        } catch (error) {
            console.log(error);
        }
    }

    componentDidMount() {
        Router.onRouteChangeComplete = url => {
            this.trackPageView(url);
        };
    }

    render() {
        const { Component, pageProps } = this.props;
        return (
            <Container>
                <Head>
                    <title key="title">Matlogica company website</title>
                    <meta
                        key="description"
                        name="description"
                        content=""
                    />
                </Head>
                <Component {...pageProps} />
            </Container>
        );
    }
}